import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID,
    ITrialItemCategoriesLoadByTrialIdAction,
    ITrialItemCategoriesLoadByTrialIdFailureAction,
    ITrialItemCategoriesLoadByTrialIdSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/trialItemCategory";
import { trialItemCategoryApi } from 'src/services/trialItemCategory';

export const
    getTrialItemCategoriesByTrialIdEpic = (action$): Observable<ITrialItemCategoriesLoadByTrialIdSuccessAction | ITrialItemCategoriesLoadByTrialIdFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID)
            .mergeMap((action: ITrialItemCategoriesLoadByTrialIdAction) => {
                return trialItemCategoryApi
                    .getTrialItemCategoriesByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialItemCategories, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }